import { useState } from 'react';
import { CheckAuth } from 'pages/auth/actions.js';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import OPWBreadcrumb from 'components/breadcrumb.js';
import Header from 'components/header.js';
import Footer from 'components/footer.js';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { AnimalAgeSelect } from 'components/animalAgeSelect.js';
import { TimezoneSelect } from 'components/timezones/timezoneSelect.js';
import { AnimalGenderSelect } from 'components/animalGenderSelect.js';
import { BreedTypeSelect } from 'components/breedTypeSelect.js';
import { WoolGrowthSelect } from 'components/woolGrowthSelect.js';
import GenericModal from 'components/genericModal.js';
import {
	SessionName,
	SessionEndDate,
	HeadCount,
	PaddockSize,
	DisplayUnits,
} from './controls.js';
import { AiOutlineDashboard } from 'react-icons/ai';

//const TITLE = 'Session Management'
const BC = OPWBreadcrumb;

export const SessionDetail = (props) => {
	return (
		<>
			<CheckAuth groupName={'admin'} />
			<Header>
				<BC
					trail={
						'[["Home", "/"], ["Session management", "/manage/session"], ["' +
						(props.values.SessionName || 'New session') +
						'", ""]]'
					}
				/>
			</Header>
			<Container fluid className="body">
				<Form onSubmit={props.handleSubmit}>
					<SessionDetailControls {...props} />
					<br />
				</Form>
			</Container>
			<Container fluid>
				<Row>
					<Col sm="12">
						<Footer />
					</Col>
				</Row>
			</Container>
		</>
	);
};

const Controls = (props) => {
	const {
		setSessionDetailShow,
		modified,
		setModified,
		valMsg,
		addingNewSession,
		setAddingNewSession,
	} = props;

	const msg = valMsg ? `Warning: ${valMsg}. Fix and try again.` : '';
	//const disableControl = (addingNewSession || weigherId === null || weigherId === undefined)
	const title = modified
		? 'click to save changes'
		: 'locked - no data modified';

	const handleExit = () => {
		if (addingNewSession) {
			setAddingNewSession(false);
		}
		setSessionDetailShow(false);
	};

	const handleSave = (e) => {
		setModified(false);
		props.handleSubmit(e);
		//aButton.setState({disabled: true});
	};

	return (
		<div className="formButtons">
			<p className={'validationError' + (msg === '' ? ' hidden' : '')}>{msg}</p>
			<ButtonGroup>
				{/* <Button
					variant="info"
					onClick={() => setSessionChangeModalShow(true)}
					{ ...(disableControl && { disabled: true }) }
				>{ modalBtnDesc }</Button> */}
				<Button
					type="submit"
					variant="outline-primary"
					title={title}
					{...(!modified && { disabled: true })}
					{...(!modified && { variant: 'outline-secondary' })}
					onClick={(e) => handleSave(e)}
				>
					Save changes
				</Button>
				<Button variant="outline-primary" onClick={() => handleExit()}>
					Exit without saving
				</Button>
				{/* <Link to = "/"><Button variant="info" { ...(!modified && { disabled: true }) }>Exit without saving</Button></Link> */}
			</ButtonGroup>
		</div>
	);
};

/**
 * This is all the detail form controls for setting data in a session
 * @param {} props
 */
export const SessionDetailControls = (props) => {
	const {
		cols,
		controlStyle,
		handleChange,
		values,
		setValues,
		defaultTimezone,
		addingNewSession,
		modalExitWithoutSavingShow,
		setModalExitWithoutSavingShow,
		modalExitWithoutSavingData,
		handleModalExitWithoutSaving,
		handleSessionStartObjChange,
		handleSessionEndObjChange,
		species,
		setSpecies,
	} = props;

	const [more, set_more] = useState(false);

	const handleCheckboxChange = (event) => {
		const checkedId = parseInt(event.target.value);
		let tempSelectedWeighers = [];
		const newValues = { ...values }; //need to create a copy of object or state won't update when using setValues()
		if (event.target.checked) {
			tempSelectedWeighers = [...newValues.selectedWeighers, checkedId];
			newValues.selectedWeighers = tempSelectedWeighers;
			setValues(newValues);
		} else {
			tempSelectedWeighers = newValues.selectedWeighers.filter(
				(id) => id !== checkedId
			);
			newValues.selectedWeighers = tempSelectedWeighers;
			setValues(newValues);
		}

		for (const w of newValues.clientWeighers) {
			if (tempSelectedWeighers.includes(w.WeigherID)) {
				newValues.timezone = w.defaultTimezone;
				newValues.species = w.Species;
				setValues(newValues);
				setSpecies(newValues.species);
				break;
			}
		}
		handleChange(event);
	};

	return (
		<Row>
			<Col>
				<Card body>
					<Card.Title>{values.SessionName || 'New session'}</Card.Title>
					<Card.Body>
						<SessionName
							cols={cols}
							controlStyle={controlStyle}
							required={true}
							handleChange={(evt) => handleChange(evt)}
							value={values.SessionName || ''}
						/>

						{!values.newSession &&
							values.weighers?.map((row, idx) => {
								//this is an edit of an existing session
								//console.log ('values:', values);
								let theStyle = {};
								if (idx === values.weighers.length - 1) {
									theStyle = { marginBottom: '20px' };
								}

								let weigher = null;
								if (values.clientWeighers) {
									weigher = values.clientWeighers.filter((obj) => {
										if (obj.WeigherID === row) {
											return obj;
										}
									});
								}
								//console.log ('weigher:', weigher);

								return (
									<Row
										className="inputRow"
										key={row.SerialNumber}
										style={theStyle}
									>
										<Col sm={cols.lhs}>{idx > 0 || 'Weigher(s):'}</Col>
										<Col sm={cols.rhs}>
											{weigher?.name} [s/n:
											{row}]{' '}
											{weigher?.WeigherLink ? (
												<a
													href={weigher.WeigherLink}
													target="_blank"
													rel="noreferrer"
												>
													<AiOutlineDashboard />
												</a>
											) : null}
										</Col>
									</Row>
								);
							})}

						{values.newSession &&
							values.clientWeighers?.map((row, idx) => {
								//this is an addition of a new session
								//console.log ('values:', values);
								let theStyle = {};
								if (idx === values.clientWeighers.length - 1) {
									theStyle = { marginBottom: '20px' };
								}
								return (
									<Row
										className="inputRow"
										key={row.WeigherID}
										style={theStyle}
									>
										<Col sm={cols.lhs}>{idx > 0 || 'Select Weigher(s):'}</Col>
										<Col sm={cols.rhs}>
											<input
												type="checkbox"
												id="Weigher"
												value={row.WeigherID}
												checked={values.selectedWeighers?.includes(
													row.WeigherID
												)}
												onChange={(event) => {
													handleCheckboxChange(event);
												}}
											/>{' '}
											{row.name} [s/n:
											{row.WeigherID}]
										</Col>
									</Row>
								);
							})}

						{!values.isYardWeights && (
							<TimezoneSelect
								cols={cols}
								controlStyle={controlStyle}
								required={true}
								handleChange={(evt) => handleChange(evt)}
								value={values.timezone || defaultTimezone}
							/>
						)}

						<Row className="inputRow">
							<Col sm={cols.lhs}>Session start:</Col>
							<Col sm={cols.rhs}>
								<DatePicker
									//id = 'sessionStartObj'
									className={'datepickerxx form-control'}
									//className = { 'datepicker' }
									dateFormat={'dd MMM yyyy HH:mm'}
									selected={values.sessionStartObj || new Date()}
									showTimeSelect
									todayButton={'Now'}
									timeIntervals={15}
									scrollableYearDropdown={true}
									showYearDropdown={true}
									onChange={(dateObj) => handleSessionStartObjChange(dateObj)}
									style={controlStyle}
									disabled={values.isYardWeights}
								/>
							</Col>
						</Row>
						{!addingNewSession && (
							<SessionEndDate
								cols={cols}
								value={values.sessionEndObj}
								handleSessionEndObjChange={handleSessionEndObjChange}
								//controlStyle = {{...{width: '15em'},...controlStyle}}
								controlStyle={controlStyle}
								lock={values.isYardWeights}
							/>
						)}

						{!values.isYardWeights && (
							<HeadCount
								cols={cols}
								controlStyle={controlStyle}
								required={true}
								handleChange={handleChange}
								value={values.Head || ''}
							/>
						)}
						<BreedTypeSelect
							cols={cols}
							controlStyle={{ ...{ width: '15em' }, ...controlStyle }}
							required={true}
							handleChange={(evt) => handleChange(evt)}
							value={values.BreedType || ''}
							species={species}
						/>
						<AnimalGenderSelect
							cols={cols}
							controlStyle={{ ...{ width: '15em' }, ...controlStyle }}
							required={true}
							handleChange={(evt) => handleChange(evt)}
							value={values.Sex || ''}
							species={species}
						/>
						<AnimalAgeSelect
							cols={cols}
							controlStyle={{ ...{ width: '15em' }, ...controlStyle }}
							required={true}
							handleChange={(evt) => handleChange(evt)}
							value={values.Age || ''}
							species={species}
						/>
						<WoolGrowthSelect
							cols={cols}
							controlStyle={{ ...{ width: '15em' }, ...controlStyle }}
							required={true}
							handleChange={(evt) => handleChange(evt)}
							value={values.WoolGrowth || ''}
							species={species}
						/>
						{!values.isYardWeights && (
							<PaddockSize
								cols={cols}
								controlStyle={controlStyle}
								required={true}
								handleChange={(evt) => handleChange(evt)}
								value={values.Paddock || ''}
								readOnly={true}
							/>
						)}
						<Row className="inputRow">
							<Col sm={cols.lhs}>
								<Button
									variant="link"
									checked={more}
									onClick={() => set_more(!more)}
								>
									{more ? '- Show less' : '+ Show more'}
								</Button>
							</Col>
						</Row>
						{more && (
							<DisplayUnits
								cols={cols}
								controlStyle={controlStyle}
								value={values.displayUnits}
								handleChange={handleChange}
							/>
						)}
						<GenericModal
							title="Exit without saving?"
							bodyTxt="You are changing sessions with changes without saving!"
							show={modalExitWithoutSavingShow}
							setShow={setModalExitWithoutSavingShow}
							buttons={[
								{ desc: 'Exit without saving changes', id: 'loseChangesBtn' },
								{ desc: 'Cancel', id: 'cancelExitBtn' },
							]}
							data={modalExitWithoutSavingData || {}}
							handleButton={(data) => handleModalExitWithoutSaving(data)}
						/>

						<Controls {...props} />
					</Card.Body>
				</Card>
			</Col>
		</Row>
	);
};
